module.exports = __webpack_public_path__ + "media/images/phone-61a8e01508ab1bdb1ebd204a1522f147.svg";